import styled from "styled-components";
import { ButtonSettings, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { Heading } from "../../../services/visualLibraryService";

export const PromotionPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    // background-color: #000;
    opacity: 0.3;
  }
`;

// export const TextStyled = styled(Text)`
//   font-weight: normal;
//   margin-bottom: ${props => props.theme.spacing.small};
//   ${props => props.bold && `font-weight: ${props.theme.font.weight.bold}`}
// `;

export const PromotionContainerStyled = styled.article`
  position: relative;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.theme.font.size.default};
  padding: ${props => props.theme.spacing.large} 0;
  height: auto;
  margin: 0 auto;
  background-color: rgba(33, 33, 33, 0.8);
  color: ${props => props.theme.color.white};
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  margin-top: ${props => props.theme.spacing.small};
  width: 20rem;
  border-radius: 0.5rem;
  background-color: ${props => `rgba(${props.theme.color.secondary}, 0.3)`};
`;

export const LogoContainerStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.large};
`;

export const LogoStyled = styled.div`
  display: block;
  ${props => props.inlineBlock && `display: inline-block;`}
  margin-top: ${props => props.theme.spacing.medium};
`;

export const SecondaryLogoStyled = styled.img`
  ${props => props.inlineBlock && `display: inline-block`}
  vertical-align: middle;
  & + & {
    margin: 0 15px;
  }
`;

export const LandingPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: absolute;
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs}%;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-color: #000;
    opacity: 0.3;
  }
`;

export const HeadingStyled = styled(Heading)`
  width: 60%;
  margin-bottom: ${props => props.theme.spacing.xlarge};
  font-weight: 400 !important;
`;

export const TextStyled = styled(Text)`
  width: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "66%" : "80%")};
  ${props =>
    props.showBullet &&
    `
    display: list-item;
    list-style-position: inside;
  `}
`;

export const TextDisclaimerStyled = styled(Text)`
  position: absolute;
  padding-bottom: inherit;
  bottom: 0;
  font-size: 1.5rem;
`;

export const LandingContainerStyled = styled.article`
  width: 80%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 0;
  top: 0;
  padding: 4%;
`;
